
import React, {Component} from 'react';

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import TutorialClick from '../components/tutorial-click'

// import camera from "../helpers/camera-helper"


const mapStateToProps = (state) => {
    return {
        tutorial: state.tutorial,
        // camera: state.camera, //camera.rot, 
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
    },
    dispatch);
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(TutorialClick);



// WEBPACK FOOTER //
// ./src/containers/tutorial.js